document.addEventListener('DOMContentLoaded', function () {
  AOS.init({
    // Global settings:
    disable: 'phone',
    startEvent: 'DOMContentLoaded',
    initClassName: 'aos-init',
    animatedClassName: 'aos-animate',
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,

    // Per-element basis settings:
    offset: 120,
    delay: 0,
    duration: 750,
    easing: 'ease',
    once: true,
    mirror: false,
    anchorPlacement: 'top-bottom',
  });
});
